module.exports = __webpack_public_path__ + "static/media/aleenacake.553837f3.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/aleenacake.JPG
// module id = 565
// module chunks = 0